import axios from 'axios';

export const fetchWholesaleCatalog = async () => {
  // Fetch from new wholesale suppliers endpoint
  const response = await axios.get('/api/wholesale-suppliers?status=active');

  // Transform to match expected format
  const suppliers = response.data.suppliers || [];
  return {
    suppliers: suppliers.map((supplier) => ({
      // Use the database _id for lookups (catalog queries expect ObjectId)
      supplierId: supplier.id || supplier._id || supplier.supplierCode,
      supplierCode: supplier.supplierCode,
      id: supplier.id || supplier._id || supplier.supplierCode,
      name: supplier.companyName,
      leadTimeDays: supplier.performance?.averageLeadTime || null,
      moq: null, // MOQ is per-item, not per-supplier
      catalogItemCount: supplier.catalogItemCount || 0
    }))
  };
};

export const fetchPatternCatalog = async () => {
  const response = await axios.get('/api/design-studio/catalog/patterns');
  return response.data;
};

export const fetchFabricCatalog = async () => {
  const response = await axios.get('/api/design-studio/catalog/fabrics');
  return response.data;
};

export const fetchDropConfiguration = async (brandId, lookId, params = {}) => {
  const response = await axios.get(`/api/design-studio/brands/${brandId}/drop-config/${lookId}`, {
    params,
  });
  return response.data;
};

export const saveDropConfiguration = async (brandId, lookId, payload) => {
  const response = await axios.post(`/api/design-studio/brands/${brandId}/drop-config/${lookId}`, payload);
  return response.data;
};

export const deleteDropAsset = async (brandId, lookId, assetId) => {
  const response = await axios.delete(
    `/api/design-studio/brands/${brandId}/drop-config/${lookId}/assets/${assetId}`
  );
  return response.data;
};
